import ApplicationController from './application_controller'
import Choices from 'choices.js'

export default class extends ApplicationController {

	static targets = [
		'select',
	]

	static values = {
		showPlaceholder:          { type: Boolean, default: false },
		placeholderText:          { type: String,  default: 'Search...' },
		removeItemButton:         { type: Boolean, default: false },
		sendEventToPassedElement: { type: Boolean, default: false },
		choices: Array,
	}

	//TODO: OnFocus disable already selected activities!
	
	connect() {
		this.initChoices()

		if (this.selectTarget.classList.contains('border-danger')) {
			this.element.querySelector('.choices__inner').classList.add('border-danger')
		}

		// this is needed because during choices initialization, selectTarget is changed and can
		// be in an invalid state without any values. Other controllers need to know the initial value
		// and can respond to this event.
		this.dispatch('initialized', { detail: { selectElement: this.selectTarget } })
	}

	disconnect() {
		this.choices.destroy()
	}

	initChoices() {
		const options = {
			placeholder: this.showPlaceholderValue,
			placeholderValue: this.placeholderTextValue,
			searchPlaceholderValue: 'Search...',
			itemSelectText: '',
			allowHTML: true,
		}

		if (this.removeItemButtonValue) options.removeItemButton = true

		if (this.hasChoicesValue) options.choices = this.choicesValue

		this.choices = new Choices(this.selectTarget, options)
		if (this.selectTarget.value != null && this.selectTarget.value != "") {
			this.choices.setChoiceByValue(this.selectTarget.value)
		}
	}

	updateChoicesFromInputFilter(attributeName, value, comparisonLambda) {
		const newChoices = this.choicesValue
			.filter(choice => {
				const filterableValues = choice[attributeName] || []
				return (filterableValues.length == 0 || comparisonLambda(filterableValues, value))
			})

		const previousValue = this.choices.getValue(true)
		this.choices.clearChoices(true, true)
		this.choices.setChoices(newChoices)
		if (newChoices.some(choice => choice.value == previousValue)) {
			this.choices.setChoiceByValue(previousValue)
		} else {
			this.choices.setChoiceByValue('')
			this.selectTarget.dispatchEvent(new Event('change', { bubbles: true }))
		}
	}

}
